import React from 'react';
import Skeleton from '@alfa-retail-react/components/skeleton';
import classNames from 'classnames';

import { WindowTypeName, windowTypeToClassName } from 'app/utils/useWindowType';
import 'app/component/skeleton/plate/PlateSkeleton.less';

export interface PlateSkeletonProps {
    /**
     * Тип окна.
     */
    windowType: WindowTypeName;
}

/**
 * Скелетон компонента шага.
 */
export const PlateSkeleton = (props: PlateSkeletonProps) => {
    const className = classNames(
        'plateSkeleton',
        windowTypeToClassName(props.windowType),
    );

    return <Skeleton className={className} visible animate />;
};
